import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withRouter, Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";

import { connect } from "react-redux";

const getUserName = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj;
  }
}

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      name: "Admin",
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  componentDidMount() {
    const userData = getUserName();
    if (userData) {
      this.setState({ name: userData.username })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success) {
      const userData = getUserName();
      if (userData) {
        this.setState({ name: userData.username })
      }
    }
  }

  render() {
    const { userdetail } = this.props;
    //
    const UserAvatarText = ({ firstName, lastName }) => {
  const initials =
    (firstName?.charAt(0) || "").toUpperCase() +
    (lastName?.charAt(0) || "").toUpperCase();

  return (
    <div
      style={{
        backgroundColor: "#03002E",
        color: "#fff",
        borderRadius: "50%",
        width: "36px",
        height: "36px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "16px",
      }}
    >
      {initials}
    </div>
  );
};
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
      <DropdownToggle
  className="btn header-item d-flex align-items-center"
  id="page-header-user-dropdown"
  tag="button"
>
  {/* Avatar with initials */}
  <UserAvatarText
    firstName={userdetail?.firstName}
    lastName={userdetail?.lastName}
  />

  {/* Name + Arrow stacked vertically */}
  <div className="d-none d-xl-flex flex-column align-items-start ms-2 lh-sm">
    <span className="fw-medium">{this.state.name}</span>
    <i className="mdi mdi-chevron-down" style={{ fontSize: "14px" }} />
  </div>
</DropdownToggle>

          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a" href="/setting/agent-profile">
              <i className="bx bx-user font-size-16 align-middle ms-1" />
              {this.props.t("Account")}
            </DropdownItem>
           <div className="dropdown-divider" />
            <Link to="/setting/support-ticket" className="dropdown-item">
              <i className=" bx bx-support font-size-16 align-middle me-1 text-danger" />
              <span>{this.props.t("Support Ticket")}</span>
            </Link>
             <div className="dropdown-divider" />
            <Link to="/setting/general/calendar" className="dropdown-item">
              <i className=" bx bx-cog font-size-16 align-middle me-1 text-danger" />
              <span>{this.props.t("Settings")}</span>
            </Link>
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
              <span>{this.props.t("Logout")}</span>
            </Link>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

ProfileMenu.propTypes = {
  t: PropTypes.any,
  success: PropTypes.string,
  userdetail:PropTypes.object
}

const mapStateToProps = state => {
  
}

export default withRouter(
  connect()(withTranslation()(ProfileMenu))
)
